import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, UrlSerializer } from '@angular/router';
import { S7FloatingLabelModule } from '@eastbanctechru/s7-ui-kit-elements';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18NextModule } from 'angular-i18next';
import { Angulartics2Module } from 'angulartics2';
import { FlatpickrDefaults, FlatpickrModule } from 'angularx-flatpickr';
import { RequestEventsHub } from 'core';
import { CookieModule, CookieService } from 'ngx-cookie';
import { SortDirective } from 'right-angled';
import { SharedModule } from 'shared/shared.module';
import { AppRoutingModule } from './app.routing.module';
import { AppFooterComponent } from './layout/app-footer/app-footer.component';
import { AppHeaderComponent } from './layout/app-header/app-header.component';
import { AppMobileMenuComponent } from './layout/app-mobile-menu/app-mobile-menu.component';
import { AppComponent } from './layout/app/app.component';
import { APP_INTERCEPTORS } from './layout/providers';
import { GlobalErrorHandler } from './layout/providers/global-error-handler';
import { I18N_PROVIDERS } from './layout/providers/i18n';
import { LowerCaseUrlSerializer } from './layout/providers/lower-case-url-serializer';

SortDirective.settings.sortableClassName = 'sortable';
SortDirective.settings.sortAscClassName = 'asc';
SortDirective.settings.sortDescClassName = 'desc';

@NgModule({
    bootstrap: [AppComponent],
    declarations: [AppComponent, AppHeaderComponent, AppMobileMenuComponent, AppFooterComponent],
    imports: [
        BrowserModule,
        CookieModule.forRoot(),
        HttpClientModule,
        RouterModule,
        SharedModule.forRoot(),
        I18NextModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        FlatpickrModule.forRoot(),
        NgSelectModule,
        NgbDropdownModule,
        S7FloatingLabelModule,
        Angulartics2Module.forRoot({
            pageTracking: {
                clearIds: true,
                clearQueryParams: true
            }
        })
    ],
    providers: [
        I18N_PROVIDERS,
        CookieService,
        RequestEventsHub,
        APP_INTERCEPTORS,
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            deps: [LOCALE_ID],
            provide: FlatpickrDefaults,
            useFactory: (locale: string) => {
                return {
                    ...new FlatpickrDefaults(),
                    ...{
                        allowInput: false,
                        altFormat: locale === 'ru' ? 'd.m.Y' : 'm/d/Y',
                        altInput: true,
                        dateFormat: 'Z',
                        mode: 'single'
                    }
                };
            }
        }
    ]
})
export class AppModule {}
